<template>
  <div class="p-0">
    <el-popover
      placement="right-start"
      v-model="popover_visible"
      width="400"
      trigger="click">

      <div v-if="popover_visible">

        <div class="d-flex justify-content-between">
          <h6>Notifications</h6>

          <template v-if="num_of_notifications">
            <a
              href="#" @click.prevent="onMarkAllAsRead"
              class="text-muted-dark">
              Mark all as read
            </a>
          </template>
        </div>

        <div
          v-for="notification in incomming_notifications.itemsAsArray()"
          :key="notification.$key"
          class="p-1 d-flex justify-content-between notification"
          @click="onMarkNotificationAsSeen(notification)">
          <font-awesome-icon icon="goalpilot" size="2x" class="mr-3 align-self-center" />
          <div style="flex: auto">
            <span v-html="notification.message" />
            <div class="small text-muted">{{notification.timestamp|fromNow}}</div>
          </div>
          <div class="delete-info">
            <font-awesome-icon icon="trash" />
          </div>
        </div>
        <!-- incomming_notifications: <pre>{{incomming_notifications.itemsAsArray()}}</pre> -->

        <span v-if="!num_of_notifications" class="p-4">No notifications</span>

        <hr />

        <h6>Invitations</h6>

        <template v-if="num_of_invitations > 0">
          <h5 class="text-center pb-2">Incomming invitations</h5>
          <ul style="/*list-style: disc; padding-left: 18px;*/" class="p-0">
            <InlineIncommingInvitation
              v-for="invitation in incomming_invitations.itemsAsArray()"
              :key="invitation.$key"
              :invitation="invitation" />
          </ul>
        </template>
        <template v-else>
          <p>No incomming invitations</p>
        </template>
      </div>

      <div
        slot="reference"
        :class="{
          'clickable': true,
          'notification-menu': true,
        }">

        <el-badge :value="num_of_notifications || num_of_invitations" is-dot>
          <font-awesome-icon size="lg" :icon="['far', 'bell']" style="margin-right: 0.1em" />
        </el-badge>

      </div>

    </el-popover>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import InlineIncommingInvitation from '@/components/Inline/InlineIncommingInvitation'
import notificationSound from "@/assets/sounds/file-sounds-1113-unconvinced.mp3";

export default {
  data() {
    return {
      popover_visible: false,
    };
  },
  created() {
    this.sound = new Audio(notificationSound)
  },
  watch: {
    num_of_invitations(newVal, oldVal) {
      // Only trigger, when new notification has arived
      if ( !this.incomming_invitations.$readyAll ) {
        return
      }

      if ( newVal > oldVal ) {
        // Play sound. Show system notification
        console.log("Ding Ding Ding!")
        this.sound.play()
        this.$message.success('You got an invitation.');
      }
    }
  },
  computed: {
    num_of_invitations() {
      return this.incomming_invitations.$id_list.length || null /* Trick to hide '0' */
    },
    incomming_invitations() {
      return this.$models.userIncommingInvitation.subscribeList()
    },
    num_of_notifications() {
      return this.incomming_notifications.$id_list.length || null /* Trick to hide '0' */
    },
    incomming_notifications() {
      return this.$models.userNotificationInbox.subscribeList()
    },
  },
  methods: {
    ...mapMutations('app', ['SET_ACTIVE_TOPBAR_MENU']),

    onMarkNotificationAsSeen(notification) {
      notification.remove(false);
    },

    onMarkAllAsRead() {
      for ( let notification of this.incomming_notifications.itemsAsArray() ) {
        notification.remove(false)
      }
    }
  },
  components: {
    InlineIncommingInvitation,
  }
};
</script>

<style>
.notification:hover {
  background: #eee;
  border-radius: 3px;
}
.notification .delete-info {
  display: none;
}
.notification:hover .delete-info {
  display: block;
}
</style>
